<template>
  <div class="dm-rounded dm-flex dm-arr">
    <div v-if="label" @click="select('/l')" class="dm-rounded">{{label}}</div>
    <div v-if="part.length == 0" @click="select('/v')" class="dm-rounded dm-val">[]</div> 
    <MItem v-else v-for="(item, index) in part" :key="index" :sel="sel" :rprefix="rprefix+'/a'+index" :prefix="prefix+'/a'" :part="item" :index="index" />
  </div>
</template>

<script>

export default {
  name: 'MArray',
  props: {
    label: String,
    part: Array,
    prefix: String,
    rprefix: String,
    sel: Object,
  },
  components: {
    MItem: () => import('./MItem.vue'),
  },
  methods: {
    isObject: function(o) { return typeof o == "object" },
    select(suffix) {
      this.$root.$emit('selected', {selection: this.rprefix + suffix, path: this.prefix + suffix})
    },
    isSelected(suffix) {
      return this.sel.selected == this.rprefix + suffix
    },
    inSelection(suffix) {
      return this.sel.selection.includes(this.rprefix + suffix)
    },
  },
}
</script>
